import { RequestContext } from '../../types/request-context';
import { StringMap } from './shared';
import { SettingsContent, SettingsContentTypes } from './settings';

export interface GetPinSettingsOutput extends SettingsContent {}

export interface PinWidgetTeen extends GetPinSettingsOutput {
    __type: SettingsContentTypes.PinWidgetTeen
    strings: StringMap;
}

export interface PinWidgetFSK18 extends GetPinSettingsOutput {
    __type: SettingsContentTypes.PinWidgetFSK18
    pinIntro: String;
    strings: StringMap;
    links: StringMap;
}

export interface PinWidgetStandard extends GetPinSettingsOutput {
    __type: SettingsContentTypes.PinWidgetStandard
    isPinSetup: boolean;
    pinLength: number;
    pinIntro: String;
    strings: StringMap;
    links: StringMap;
    token: string;
}


// SetPinOrUsage
export interface SetPinOrUsageInput {
    context: RequestContext;
    setPinType: SetPinType;
    token: string;
    pin?: string;
    teenId?: string;
    enablePurchase?: boolean;
}

export enum SetPinType {
    pin = 'pin',
    purchase = 'purchase',
}

export interface SetPinOrUsageOutput {
    message: string;
    success: boolean;
    returnUrl: string;
}
